import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      // props: true,
      component: Home
    },
    {
      path: '/om-oss',
      name: 'about',
      // props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/aktiviteter',
      name: 'aktiviteter',
      // props: true,
      component: () => import('./views/Aktiviteter.vue')
    },
    {
      path: '/aktiviteter/:id',
      name: 'aktiviteterInfo',
      // props: true,
      component: () => import('./views/AktiviteterInfo.vue')
    },
    {
      path: '/søke-barnehageplass',
      name: 'barnehageplass',
      // props: true,
      component: () => import('./views/barnehageplass.vue')
    },
    {
      path: '/kontakt-oss',
      name: 'kontaktOss',
      // props: true,
      component: () => import('./views/KontaktOss.vue')
    },
    {
      path: '/aktiviteterBilde/:id',
      name: 'aktiviteterBilde/:id',
      // props: true,
      component: () => import('./views/aktiviteterBilde.vue')
    },
  ]
})
